@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $alert-display;
}

.alert {
  display: flex;
  position: relative;
  align-items: start;
  width: $alert-width;
  max-width: $alert-width;
  padding-top: $alert-padding-top;
  padding-right: $alert-padding-right;
  padding-bottom: $alert-padding-bottom;
  padding-left: $alert-padding-left;
  border-width: $alert-border-width;
  border-style: $alert-border-style;
  border-color: $alert-border-color;
  border-top-width: $alert-border-top-width;
  border-radius: $alert-border-radius;
  font-family: $alert-font-family;
  background: $alert-background-color;
  justify-items: stretch;

  &.hidden {
    display: none;
  }

  &-heading {
    display: flex;
    position: relative;
    align-items: $alert-heading-align;
    min-height: $alert-heading-height;
    color: $alert-heading-color;
    font-family: $alert-heading-font-family;
    font-size: $alert-heading-font-size;
    font-weight: $alert-heading-font-weight;
    line-height: $alert-heading-line-height;
  }

  &-danger {
    color: $alert-color-danger;
  }

  &-warning {
    color: $alert-color-warning;
  }

  &-info {
    color: $alert-color-info;
  }

  &-success {
    color: $alert-color-success;
  }

  &-text {
    color: $alert-color-text;
  }

  &-icon {
    margin-right: $alert-icon-margin-right;
  }

  &-close-button {
    color: $alert-close-button-color;
    cursor: pointer;

    &-wrapper {
      display: flex;
      padding-top: $alert-close-button-padding-top;
      padding-right: $alert-close-button-padding-right;
      padding-bottom: $alert-close-button-padding-bottom;
      padding-left: $alert-close-button-padding-left;
      align-self: flex-start;
      max-height: $alert-heading-height;
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    color: $alert-content-color;
  }
}

@media (max-width: $breakpoint-mobile) {
  .alert {
    border-top-width: $mobile-alert-border-top-width;
  }

  .alert-icon {
    margin-right: $mobile-alert-icon-margin-right;
  }
}
